export enum ErrorCodes {
    VIDEO_ERROR = 'CR-001',
    UNAUTHORIZED = 'CR-002',
    FORBIDDEN = 'CR-003',
    CONFLICT = 'CR-004',
    REFRESH_TOKEN_EXPIRED = 'CR-005',
    NO_AD_TAG_PARAMS = 'CR-006',
    NO_REALM_DATA = 'CR-007',
    NO_AUTH_TOKEN = 'CR-008',
    INVALID_BEACON_DATA = 'CR-009'
}
